// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		lengthArr:[],
	},
	getters: {
		
	},
	mutations: {
		set_lengthArr(state, params) {
			state.lengthArr = params;
		},
	},
	actions: {

	},
};
